import {defineStore} from 'pinia'

export type NotificationAction = {
    label: string
    url: string
}

export type NotificationData = {
    content: string
    action?: NotificationAction | null
}

export type Notification = {
    id: number | string
    type: string
    data: NotificationData
    created_at: string
    read_at: string | null
}

export const useNotificationStore = defineStore('notifications', {

    state: () => ({
        timeline: useAsyncState(() => $lara.get('/app/spa/notifications') as Promise<Notification[]>, []),
    }),
    getters: {
        unreadNotificationsCount(state) {
            return state.timeline?.state?.filter(notification => !notification.read_at).length
        },
    },

    actions: {
        async markAllAsRead() {
            await $lara.put('/app/spa/notifications/markAsRead')
            await this.$state.timeline.execute()
        },
        async refreshTimeline() {
            await this.$state.timeline.execute()
        }
    }
})
